import {
  Types as ListaTypes,
  Creators as ListaActions,
} from '../store/ducks/lista';

const socketMiddleware = (storeAPI) => (next) => async (action) => {
  switch (action.type) {
    case ListaTypes.IMPORTAR_LOTE_REQUEST: {
      action.payload.params.connection.on('updateProgress', (resp) => {
        if (resp.progressValue !== 0)
          storeAPI.dispatch(
            ListaActions.importarLoteUpdateProgress(resp.id, resp.progressValue)
          );
      });
      break;
    }
    case ListaTypes.IMPORTAR_LOTE_NESTLE_REQUEST: {
      action.payload.params.connection.on('updateProgress', (resp) => {
        if (resp.progressValue !== 0)
          storeAPI.dispatch(
            ListaActions.importarLoteUpdateProgress(resp.id, resp.progressValue)
          );
      });
      break;
    }
    default:
  }

  return next(action);
};

export default socketMiddleware;
